(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-dom"), require("react-transition-group"), require("react"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define([, , , ], factory);
	else if(typeof exports === 'object')
		exports["smartcharts"] = factory(require("react-dom"), require("react-transition-group"), require("react"), require("moment"));
	else
		root["smartcharts"] = factory(root["ReactDOM"], root["ReactTransitionGroup"], root["React"], root["moment"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__1807__, __WEBPACK_EXTERNAL_MODULE__6985__, __WEBPACK_EXTERNAL_MODULE__868__, __WEBPACK_EXTERNAL_MODULE__8692__) => {
return 